import { extractUrl, isShortLink, parseMapsLink, type ParseResult } from "@viamissa/gmaps-link";

/** Parse a pasted link, expanding a short link through the site's resolver first. */
export async function readLink(text: string): Promise<ParseResult> {
  const url = extractUrl(text) ?? text.trim();
  if (!isShortLink(url)) return parseMapsLink(url);

  const response = await fetch(`/api/resolve?${new URLSearchParams({ url })}`);
  const body = (await response.json().catch(() => ({}))) as { url?: string; error?: string };
  if (!response.ok || !body.url) {
    return { ok: false, error: body.error ? `Couldn't expand the short link: ${body.error}.` : "Couldn't expand the short link." };
  }
  return parseMapsLink(body.url);
}
